import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import FilterView from "../../common/filter";
import type EnforcementUsersViewModel from "viewModels/enforcement/enforcementUsers/enforcementUsersViewModel";
import { Input } from "@frui.ts/bootstrap";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import { Form } from "react-bootstrap";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { translateGeneral } from "utils/localizations";
import AdvancedInput from "@edaz/edazkit/controls/AdvancedInput";

export interface EnforcementUserFiltersProps {
  vm: EnforcementUsersViewModel;
}

const EnforcementUserFilters = observer((props: EnforcementUserFiltersProps) => {
  const { vm } = props;
  const guidRegex = new RegExp(/[^A-F0-9-]+/gi);

  return (
    <FilterView vm={vm}>
      <Form.Row>
        <FormGroup as={Col} md={6} lg={4} xl={3} target={vm.filter} property="code">
          <FormLabel>{vm.translateFilterAttribute("code")}</FormLabel>
          <Input placeholder={vm.translate("fillCode")} />
        </FormGroup>
        <FormGroup as={Col} md={6} lg={4} xl={3} target={vm.filter} property="id">
          <FormLabel>{vm.translateFilterAttribute("id")}</FormLabel>
          <AdvancedInput
            target={vm.filter}
            property="chargeId"
            placeholder={vm.translate("fillId")}
            ignoredCharacters={guidRegex}
          />
        </FormGroup>
        <FormGroup as={Col} md={6} lg={4} xl={3} target={vm.filter} property="userType">
          <FormLabel>{vm.translateFilterAttribute("userType")}</FormLabel>
          <AdvancedSelect
            target={vm.filter}
            property="userType"
            items={vm.enforcementUserTypeOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />{" "}
        </FormGroup>
        <FormGroup as={Col} md={6} lg={4} xl={3} target={vm.filter} property="isManager">
          <FormLabel>{vm.translateFilterAttribute("isManager")}</FormLabel>
          <AdvancedSelect
            target={vm.filter}
            property="isManager"
            items={vm.booleanOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />{" "}
        </FormGroup>
      </Form.Row>
    </FilterView>
  );
});

export default EnforcementUserFilters;
